var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"response__container"},[_c('v-list-item-content'),_c('b-list-group',[_c('b-list-group-item',[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"label":"Redirecting to status page... Please Wait..."}}),_c('h6',{staticClass:"mt-1"},[_vm._v("Redirecting to status page... Please Wait...")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }